var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bot van-multi-ellipsis--l5",on:{"click":function($event){return _vm.ViewRemark()}}},[_vm._v("\n    "+_vm._s(_vm.remark)+"\n  ")]),_c('van-popup',{staticClass:"pop_content",model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(_vm._s(_vm.remark))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }